module.exports = __webpack_public_path__ + "static/media/white-logo-full.71b89089.png";